import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M12.0511 21.949C6.72623 21.9444 2.3389 17.7679 2.07231 12.4497C1.80572 7.13142 5.75338 2.53708 11.0511 2V6.04C8.04176 6.54858 5.89505 9.23721 6.06528 12.2845C6.23551 15.3318 8.66832 17.7646 11.7156 17.9349C14.7629 18.1051 17.4516 15.9584 17.9601 12.949H22.0001C21.4799 18.0555 17.1831 21.9421 12.0501 21.949H12.0511ZM22.0011 10.949H17.9611C17.5356 8.4347 15.5655 6.46506 13.0511 6.04V2C17.7782 2.48398 21.5156 6.22098 22.0001 10.948L22.0011 10.949Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "DoughnutChart"
);
